var _defs, _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _polygon, _path15, _path16, _circle4, _path17, _path18, _path19, _path20, _path21, _ellipse, _ellipse2, _path22, _polygon2, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlerte2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f71115d1-abc3-47ac-8361-b6e087de44cd",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 719.18 739.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6e6e6;}.cls-2{fill:#17243f;}.cls-3{fill:#a8ce29;}.cls-4{fill:#fff;}.cls-5{fill:#9f616a;}.cls-6{fill:#2f2e41;}.cls-7{fill:#3f3d56;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "alerte") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.14,651.25C84.24,680.1,70.47,739,70.47,739S18.77,707.57,6.66,678.73s-7.26-58.38,10.82-66S60,622.41,72.14,651.25Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 387.57,
    cy: 252.79,
    r: 16.61
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 387.57,
    cy: 142.79,
    r: 16.61
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 387.57,
    cy: 32.79,
    r: 16.61
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M448,0a5,5,0,0,0-5,5V60.58a5,5,0,0,0,5,5H714.18a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M449.84,3.9a2.9,2.9,0,0,0-2.9,2.9v52a2.9,2.9,0,0,0,2.9,2.9H712.38a2.9,2.9,0,0,0,2.9-2.9V6.8a2.9,2.9,0,0,0-2.9-2.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M695.9,47.43a4.71,4.71,0,0,0,0-9.42H473.84a4.71,4.71,0,0,0,0,9.42Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M569.39,27a4.71,4.71,0,1,0,0-9.42H473.84a4.71,4.71,0,1,0,0,9.42Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M448,110a5,5,0,0,0-5,5v55.58a5,5,0,0,0,5,5H714.18a5,5,0,0,0,5-5V115a5,5,0,0,0-5-5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M449.84,113.9a2.9,2.9,0,0,0-2.9,2.9v52a2.9,2.9,0,0,0,2.9,2.9H712.38a2.9,2.9,0,0,0,2.9-2.9v-52a2.9,2.9,0,0,0-2.9-2.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M695.9,157.43a4.71,4.71,0,0,0,0-9.42H473.84a4.71,4.71,0,0,0,0,9.42Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M569.39,137a4.71,4.71,0,1,0,0-9.42H473.84a4.71,4.71,0,1,0,0,9.42Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M448,220a5,5,0,0,0-5,5v55.58a5,5,0,0,0,5,5H714.18a5,5,0,0,0,5-5V225a5,5,0,0,0-5-5Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M449.84,223.9a2.9,2.9,0,0,0-2.9,2.9v52a2.9,2.9,0,0,0,2.9,2.9H712.38a2.9,2.9,0,0,0,2.9-2.9v-52a2.9,2.9,0,0,0-2.9-2.9Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M695.9,267.43a4.71,4.71,0,0,0,0-9.42H473.84a4.71,4.71,0,0,0,0,9.42Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M569.39,247a4.71,4.71,0,1,0,0-9.42H473.84a4.71,4.71,0,1,0,0,9.42Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M152.33,462.53h0a13.89,13.89,0,0,1-11.18-17.65l10.53-35.8,16,3,.69,36.46a13.89,13.89,0,0,1-16,14Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "244.68 691.08 224.68 688.08 229.68 493.08 201.68 577.08 186.68 695.08 167.68 690.08 163.68 567.08 185.68 422.08 295.68 447.08 244.68 691.08"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M235.49,739.08h0a14.7,14.7,0,0,1-14.7-14.7q0-.72.07-1.44L224,691.37a4.63,4.63,0,0,1,2.41-3.62c5.9-3.18,12-2.41,18.16,1.74a4.61,4.61,0,0,1,2,3.28l3.54,29.88a14.7,14.7,0,0,1-14.6,16.43Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M153.86,736.73h0a13.24,13.24,0,0,1-6.43-19.82l21.33-31.71c7.69-5.52,12.33-2.83,14.13,7.48l4.31-10.81,3.25,3.55a10.34,10.34,0,0,1,.55,13.32l-22.13,33.68A13.24,13.24,0,0,1,153.86,736.73Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 288.68,
    cy: 204.08,
    r: 30
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M307.68,259.08l-51-10c6.57-14,11.83-18.75,6-34h41C300.06,230.88,303.56,245.7,307.68,259.08Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.68,461.08l-120-34c24-52.9,29.07-111,21.94-172.38a11.11,11.11,0,0,1,9.74-12.32l.41,0c15.65-1.29,32-2.94,48.91-5.26l19,13,22-5c7.06,3.42,14.17,6.27,20.59,9.1a25.74,25.74,0,0,1,14,31.65C318.7,344.89,305.62,403.38,301.68,461.08Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.68,416.08l-23-3,54.49-157c2.77-8,9.64-12.31,18-13.5l8,1-6,93Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.84,386.07h0a18.23,18.23,0,0,1-18.23-11.18l-21.93-52.8,18-65,4.76,3q.69.44,1.36.9c13.7,9.4,20.37,26.17,17.58,42.55l-4.69,27.53L367,372.66A18.23,18.23,0,0,1,350.84,386.07Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M291,159.62h0a31.86,31.86,0,0,1,14.55,4.29c1,.59.55,2.73,1.49,3.43,1.19.88,3.77.35,4.82,1.38a31.93,31.93,0,0,1,9.49,25.72l-1.67,16.64-3.95-4.32a41.16,41.16,0,0,0-27.45-13.48l-1.35-.07,3-5.32-5.28,5.28a51.41,51.41,0,0,0-7.19.59l4-7.07-7.75,7.75h0a20.73,20.73,0,0,0-14.48,11.81l-.86,1.91-1-15.88a32,32,0,0,1,31.3-32.69Q289.88,159.57,291,159.62Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 318.87,
    cy: 209.88,
    rx: 2.41,
    ry: 5.72
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 258.63,
    cy: 208.08,
    rx: 2.41,
    ry: 5.72
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M375.87,284.53h0a13.89,13.89,0,0,1,9.64,18.53L372,337.84l-15.69-4.35,2.41-36.39a13.89,13.89,0,0,1,17.16-12.58Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "357.68 384.08 332.68 368.08 353.68 325.08 379.68 335.08 366.68 373.08 357.68 384.08"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "349.03 739.78 45.29 739.78 45.29 737.67 349.41 737.67 349.03 739.78"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerte2);
export default __webpack_public_path__ + "static/media/alerte2.d432fdd7.svg";
export { ForwardRef as ReactComponent };